import { render, staticRenderFns } from "./BookRequestDlg.vue?vue&type=template&id=65dfd4c4&scoped=true"
import script from "./BookRequestDlg.ts?vue&type=script&lang=ts&external"
export * from "./BookRequestDlg.ts?vue&type=script&lang=ts&external"
import style0 from "./BookRequestDlg.scss?vue&type=style&index=0&id=65dfd4c4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dfd4c4",
  null
  
)

export default component.exports